import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import CustomerCreateDialog from './CustomerCreateDialog';
import CustomerCreateForm from './CustomerCreateForm';


import AbEnvironment from '../auth/AbEnvironment';
import CustomerFetch from './CustomerFetch';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Hidden, List, ListItem, ListItemText, MenuItem, Paper, 
         Radio, TextField, Tooltip, Typography
} from '@mui/material';
import Add from '@mui/icons-material/Add';
import Search from '@mui/icons-material/Search';

const abEnvironment = new AbEnvironment();

function renderInputComponent(inputProps) {
   const { classes, inputRef = () => {}, ref, ...other } = inputProps;
  
  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}
  
function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.accountName, query);
  const parts = parse(suggestion.accountName, matches);
  
  return (
    <MenuItem selected={isHighlighted} component="div">
      <Grid container spacing={2} direction="row" justifyContent="flex-start">
        <Grid item xs={5}>
          <Typography variant="subtitle1">
          {parts.map((part, index) => {
            if (part.highlight) {
              return (<strong key={index}>{part.text}</strong>);
            } else {
              return (part.text);
            }
          })}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="subtitle1" data-recording-sensitive>
            {suggestion.contactFirstName} {suggestion.contactLastName}
          </Typography>
        </Grid>
      </Grid>
    </MenuItem>
  );
}

const getSuggestionValue = suggestion => suggestion.accountName;

//these two needed to make warnings go away in autoselect.  Should not be the case according to doc.
function getSectionSuggestions(section) {
  return null;
}

function renderSectionTitle(section) {
  return null;
}

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      marginTop: 16,
      //padding: theme.spacing(3),
      textAlign: 'left',
      maxWidth: 980
    },
    configGrid: {
      marginTop: 4,
    },
    button: {
      marginTop: 15,
      marginBottom: 15,
      marginRight: 8
    },
    customText: {
      margin: 8
    },
    searchList: {
      paddingTop: 0,
      width: '100%'
    },
    input: {
    }
});

class CustomerSelect extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      suggestions: [],
      searchP: '',
      customerSearching: false,
      lowCustomerCount: false,
      customerCreateDialogOpen: false
    }

    this.provisioner = {
      userId:           abEnvironment.getUserAttribute('u_id'),
      accountId:        abEnvironment.getUserAttribute('a_id'),
      accountName:      abEnvironment.getUserAttribute('a_accountName'),
      description:      abEnvironment.getUserAttribute('a_description'),
      contactLastName:  abEnvironment.getUserAttribute('a_lastName'),
      contactFirstName: abEnvironment.getUserAttribute('a_firstName'),
      contactEmail:     abEnvironment.getUserAttribute('a_email'),
      contactPhone:     abEnvironment.getUserAttribute('a_phone'),
      address1:         abEnvironment.getUserAttribute('a_address1'),
      address2:         abEnvironment.getUserAttribute('a_address2'),
      city:             abEnvironment.getUserAttribute('a_city'),
      state:            abEnvironment.getUserAttribute('a_state'),
      country:          abEnvironment.getUserAttribute('a_country'),
      postalCode:       abEnvironment.getUserAttribute('a_postalCode')
    }
    this.customerSelected = false;
  }

  componentDidMount() {
    this.fetchCustomerCount();
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create (select customer step)'); }
  }

  handleRadioChange = event => {
    let theNum = parseInt(event.target.value, 10);
    if (theNum === 0) {
      this.setStateFromSelection(this.provisioner);
      this.setState({searchP: ''});
    } else {
      // Set to customer.  To do this, clear the bcUser
      let clearedUser =  {
        userId:         abEnvironment.getUserAttribute('u_id'),  // Bindcard user is the provisioner
        usingAccountId: null,
        accountName:    null,
        description:    null,
        userName:       null,
        lastName:       null,
        firstName:      null,
        email:          null,
        phone:          null,
        address1:       null,
        address2:       null,
        city:           null,
        state:          null,
        country:        null,
        postalCode:     null,
        marqetaUid:     null,
        mCardToken:     null
      };
      this.setStateFromSelection(clearedUser);
      this.setState({searchP: ''});
    }
  }

  handleChange = name => event => {
    if (name === 'searchP') {
      this.setState({searchP: event.target.value});
    }
  };

  getCustomerError = () => {
    if( this.state.searchP.length > 0 
      && (this.state.suggestions === undefined || this.state.suggestions.length === 0) 
      && (this.props.bcUser.accountName !== this.state.searchP)
      && (!this.customerSearching)
    ) {
      return <Typography style={{paddingLeft: 38, marginTop : -15}}>No matching customers</Typography>
    } else {
      return '';
    }
  }

  setStateFromSelection(theCust) {
   // Setup the new capp...
    let nobj = {
      userId:         abEnvironment.getUserAttribute('u_id'),  // Bindcard user is the provisioner
      usingAccountId: theCust.accountId,
      accountName:    theCust.accountName,
      description:    theCust.description,
      lastName:       theCust.contactLastName,
      firstName:      theCust.contactFirstName,
      email:          theCust.contactEmail,
      phone:          theCust.contactPhone,
      address1:       theCust.address1,
      address2:       theCust.address2,
      city:           theCust.city,
      state:          theCust.state,
      country:        theCust.country,
      postalCode:     theCust.postalCode,
      marqetaUid:     null,
      mCardToken:     null,
    }

    var newAppCreateStateBcUserVals = {
      bcUser: nobj
    };
    this.setAppCreateState(newAppCreateStateBcUserVals);
 }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({customerSearching: true});
    this.fetchCustomers(value);
  }
    
  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
    //if customer selected is false, that means the user did not actually select a customer from suggestions list.  Need to reset search box
    if (!this.customerSelected && this.props.bcUser.accountName && this.props.bcUser.usingAccountId !== this.provisioner.accountId) {
      //already a customer selected and it is not reseller
      this.setState({searchP: this.props.bcUser.accountName});
    } else if (!this.customerSelected && this.props.bcUser.usingAccountId === this.provisioner.accountId) {
      //already a selected and it is reseller
      this.setState({searchP: ''});
    } else {
      this.customerSelected = false;
    }
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{
    // alert(suggestionValue);
    let customerLabel = suggestion.accountName;
    this.customerSelected = true;
    this.setStateFromSelection(suggestion);
    this.setState({searchP: customerLabel});
   } 

  /*
   * Get a customer count (with a search of nothing)
   * 11 is requested because 10 is the max that can fit.
   */
  fetchCustomerCount = () => {
    CustomerFetch.fetch("", 1, 11).toPromise()
    .then(cf => {
      const thenodes = cf.accountsearchbycustomername2.nodes;

      if (thenodes.length <= 10) {
        this.setState({lowCustomerCount: true});
        if (thenodes.length === 1) {
          let customerLabel = cf.accountsearchbycustomername2.nodes[0].accountName;
          this.customerSelected = true;
          this.setStateFromSelection(cf.accountsearchbycustomername2.nodes[0]);
          this.setState({searchP: customerLabel});
        }
     }
 
    })
    .catch(err => {
      //nothing to do....user will just need to search.
    })
  }

   /*
   * Lookup customers for selection.
   */
  fetchCustomers = (searchParm) => {
    CustomerFetch.fetch(searchParm, 1, 10).toPromise()
    .then(cf => {
      const thenodes = cf.accountsearchbycustomername2.nodes;

      let theCustomers = [];
      thenodes.forEach(n => {
        theCustomers.push(n);
      });

      this.setState({suggestions: theCustomers, customerSearching: false});
    })
    .catch(err => {
      this.setState({suggestions: [], customerSearching: false});
    })
  }

  setAppCreateState = (aValue) => {
    this.props.setAppCreateState(aValue);
  };

  shouldAutoRender = (value) => {
    if (this.state.lowCustomerCount || value !== "") {
      return true;
    } else {
      return false;
    }
  }

  
  showCustomerCreateDialog = () => {
    this.setState({customerCreateDialogOpen: true});
  };

  handleCustomerCreateClose = (theCust) => {
 
    //is the cust non null and reasonable?
    if (theCust && theCust.accountId && theCust.accountName) {
      //console.log('setting state from customer ' + JSON.stringify(theCust));
      this.setStateFromSelection(theCust);
      let customerLabel = theCust.accountName;
      this.customerSelected = true;
      this.setState({searchP: customerLabel});
    }
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create (closed customer create form)'); }

    this.setState({customerCreateDialogOpen: false});
  };

  render() {
    const classes = this.props.classes;
    const {isTransferredCustomer } = this.props.auth;

    // Provisioner attributes are on this.provisioner
    // Determine what to show
    let resellerOrCustomer = 1; // 0 is reseller, 1 is customer, default to customer
    let customerLabel = 'My customer - search for a customer by name';
    if (this.props.bcUser != null && this.props.bcUser.usingAccountId != null)
    {
      // A user has been chosen.  Is the user the reseller or a customer?
      if (this.props.bcUser.usingAccountId === this.provisioner.accountId) {
        resellerOrCustomer = 0;
      } else {
        resellerOrCustomer = 1;
        customerLabel = this.props.bcUser.accountName;
       }
    }

    let inpValue = this.state.searchP;
    if (inpValue == null)
        inpValue = '';

    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }
  
  
    let actionText = 'I am adding a subscription for...';
    if (expensingActive === true) {
      actionText = 'I am buying a subscription for...';
    }
 
    // Show a radio button - for me, or for my customer
    // - if for me, just show my name and information
    // - if for my customer, show the selection, and when selected, name and information
    return (
      <div>
        <Paper className={classes.paper}>
          <List>
            <ListItem>
              <Typography variant="h6" >
                  {actionText}
              </Typography>
            </ListItem>
            <ListItem>
              <Radio
                checked={resellerOrCustomer === 0}
                  onChange={this.handleRadioChange}
                  value={0}
                  name='who-rb'
                  aria-label='Me'
              />
              <ListItemText primary={this.provisioner.accountName + ' (Me)'}/>
            </ListItem>
            {!isTransferredCustomer() &&
             <ListItem>
              <Radio
                checked={resellerOrCustomer === 1}
                  onChange={this.handleRadioChange}
                  value={1}
                  name='who-rb'
                  aria-label='My customer'
              />
              {(abEnvironment.getUserAttribute("cust_count") !== '0') && (
               <div className={classes.searchList}>
                  <Autosuggest
                    renderInputComponent={renderInputComponent}
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    shouldRenderSuggestions={this.shouldAutoRender}
                    multiSection={false}
                    renderSectionTitle={renderSectionTitle}
                    getSectionSuggestions={getSectionSuggestions}
                    inputProps={{
                      classes,
                      placeholder: customerLabel,
                      value: inpValue,
                      onChange: this.handleChange('searchP')
                    }}
                    theme={{
                      input: classes.input,
                      container: classes.container,
                      suggestionsContainerOpen: classes.suggestionsContainerOpen,
                      suggestionsList: classes.suggestionsList,
                      suggestion: classes.suggestion,
                    }}
                    renderSuggestionsContainer={options => (
                      <Paper {...options.containerProps} square>
                        {options.children}
                      </Paper>
                    )}                   
                  /><Search color="disabled" style={{float: "right", marginTop: -26}}/>
               
                </div>
              )}
              {(abEnvironment.getUserAttribute("cust_count") !== '0') && (

                <Typography variant="body1">&nbsp;&nbsp;&nbsp;or&nbsp;&nbsp;&nbsp;</Typography>
                )}
                
                <Tooltip title="Add a new customer">
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => {this.showCustomerCreateDialog();}}>
                      <Hidden only={['xs', 'sm']}>
                        <Add/>New&nbsp;Customer&nbsp;
                      </Hidden>
                      <Hidden only={['md', 'lg', 'xl']}>
                        <Add/>&nbsp;
                      </Hidden>
                  </Button>
                </Tooltip>
 
            </ListItem>
            }
           <ListItem>
              {!this.state.customerSearching && (
                <Grid item xs={12}>
                  {this.getCustomerError()}
                </Grid>
              )
              }
            

            </ListItem>
          </List>
          
        </Paper>

        <CustomerCreateDialog
          title="Create customer"
          open={this.state.customerCreateDialogOpen}
          onClose={this.handleCustomerCreateClose} >

            <CustomerCreateForm
              auth={this.props.auth}
              
              onClose={this.handleCustomerCreateClose}>
          </CustomerCreateForm>


        </CustomerCreateDialog>

      </div>
    );
  }
}

export default withStyles(styleSheet)(CustomerSelect);
